var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPlaystore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 242,
    height: 69,
    viewBox: "0 0 242 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1004_6351)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M234.408 0.5H7C3.41015 0.5 0.5 3.41015 0.5 7V61.0556C0.5 64.6454 3.41015 67.5556 7 67.5556H234.408C237.998 67.5556 240.908 64.6454 240.908 61.0556V7C240.908 3.41015 237.998 0.5 234.408 0.5Z",
    fill: "#161B22"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.714 36.3539C116.722 36.3539 113.468 39.3977 113.468 43.5899C113.468 47.7566 116.722 50.8259 120.714 50.8259C124.707 50.8259 127.961 47.7566 127.961 43.5899C127.959 39.3977 124.705 36.3539 120.714 36.3539ZM120.714 47.9778C118.526 47.9778 116.64 46.1692 116.64 43.5916C116.64 40.9868 118.528 39.2054 120.714 39.2054C122.901 39.2054 124.787 40.9868 124.787 43.5916C124.787 46.1675 122.901 47.9778 120.714 47.9778ZM104.906 36.3539C100.914 36.3539 97.6607 39.3977 97.6607 43.5899C97.6607 47.7566 100.914 50.8259 104.906 50.8259C108.899 50.8259 112.153 47.7566 112.153 43.5899C112.153 39.3977 108.899 36.3539 104.906 36.3539ZM104.906 47.9778C102.718 47.9778 100.833 46.1692 100.833 43.5916C100.833 40.9868 102.72 39.2054 104.906 39.2054C107.094 39.2054 108.979 40.9868 108.979 43.5916C108.981 46.1675 107.094 47.9778 104.906 47.9778ZM86.1045 38.5759V41.6452H93.433C93.2141 43.3722 92.6404 44.6329 91.7647 45.5091C90.6988 46.5776 89.0305 47.7566 86.1045 47.7566C81.5934 47.7566 78.0667 44.1106 78.0667 39.5883C78.0667 35.066 81.5934 31.4199 86.1045 31.4199C88.5383 31.4199 90.3153 32.3795 91.6272 33.613L93.7877 31.4471C91.9547 29.693 89.5227 28.3506 86.1045 28.3506C79.9251 28.3506 74.73 33.3935 74.73 39.5883C74.73 45.783 79.9251 50.8259 86.1045 50.8259C89.4395 50.8259 91.9564 49.7285 93.9235 47.6733C95.9465 45.6452 96.5762 42.7937 96.5762 40.4917C96.5762 39.7805 96.5219 39.1221 96.4116 38.5742H86.1045V38.5759ZM163.001 40.9596C162.4 39.3433 160.567 36.3539 156.821 36.3539C153.103 36.3539 150.012 39.2871 150.012 43.5899C150.012 47.646 153.076 50.8259 157.176 50.8259C160.484 50.8259 162.398 48.7979 163.193 47.6188L160.732 45.9736C159.912 47.1799 158.79 47.9744 157.176 47.9744C155.564 47.9744 154.415 47.2343 153.676 45.7813L163.328 41.7796L163.001 40.9596ZM153.157 43.3721C153.076 40.5751 155.318 39.151 156.932 39.151C158.189 39.151 159.255 39.7822 159.611 40.6857L153.157 43.3721ZM145.311 50.3887H148.481V29.1196H145.311V50.3887ZM140.114 37.9719H140.006C139.294 37.1212 137.926 36.3539 136.206 36.3539C132.596 36.3539 129.288 39.5338 129.288 43.6189C129.288 47.675 132.596 50.8276 136.206 50.8276C137.928 50.8276 139.294 50.0603 140.006 49.1841H140.114V50.2253C140.114 52.9935 138.638 54.4737 136.26 54.4737C134.318 54.4737 133.115 53.0769 132.623 51.8978L129.861 53.0496C130.654 54.9671 132.759 57.3252 136.26 57.3252C139.978 57.3252 143.123 55.1322 143.123 49.7864V36.7946H140.116V37.9719H140.114ZM136.479 47.9778C134.291 47.9778 132.46 46.1403 132.46 43.6189C132.46 41.0685 134.291 39.2054 136.479 39.2054C138.638 39.2054 140.333 41.0685 140.333 43.6189C140.333 46.1403 138.638 47.9778 136.479 47.9778ZM177.858 29.1196H170.27V50.3887H173.435V42.3309H177.856C181.366 42.3309 184.818 39.7839 184.818 35.7261C184.818 31.6683 181.368 29.1196 177.858 29.1196ZM177.939 39.3705H173.435V32.08H177.939C180.307 32.08 181.651 34.0451 181.651 35.7261C181.651 37.3731 180.307 39.3705 177.939 39.3705ZM197.511 36.3165C195.218 36.3165 192.844 37.3288 191.861 39.573L194.672 40.7486C195.273 39.5729 196.393 39.1884 197.566 39.1884C199.203 39.1884 200.868 40.1735 200.896 41.9243V42.1437C200.322 41.8154 199.093 41.3237 197.593 41.3237C194.563 41.3237 191.478 42.9927 191.478 46.1114C191.478 48.9578 193.963 50.7902 196.746 50.7902C198.874 50.7902 200.049 49.8323 200.785 48.7094H200.894V50.3512H203.952V42.1965C203.954 38.4228 201.14 36.3165 197.511 36.3165ZM197.128 47.9727C196.093 47.9727 194.645 47.4521 194.645 46.1658C194.645 44.524 196.447 43.8945 198.004 43.8945C199.394 43.8945 200.05 44.1956 200.896 44.6057C200.649 46.5776 198.957 47.9727 197.128 47.9727ZM215.089 36.781L211.459 46.0025H211.35L207.582 36.781H204.171L209.821 49.669L206.6 56.8386H209.903L218.611 36.781H215.089ZM186.566 50.3887H189.731V29.1196H186.566V50.3887Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5515 16.7746C85.5515 18.2003 85.1306 19.3351 84.2871 20.1824C83.3299 21.1897 82.0807 21.6933 80.5465 21.6933C79.0767 21.6933 77.8259 21.1829 76.7991 20.162C75.7706 19.1395 75.2563 17.8737 75.2563 16.3628C75.2563 14.8503 75.7706 13.5845 76.7991 12.5636C77.8259 11.5411 79.0767 11.0307 80.5465 11.0307C81.2763 11.0307 81.9738 11.1736 82.6357 11.4577C83.2993 11.7435 83.8305 12.123 84.2277 12.5976L83.3333 13.496C82.6595 12.6878 81.7311 12.2846 80.5448 12.2846C79.4722 12.2846 78.5455 12.6623 77.7631 13.4177C76.9807 14.1731 76.5903 15.1548 76.5903 16.3611C76.5903 17.5674 76.9807 18.5491 77.7631 19.3045C78.5455 20.0599 79.4722 20.4376 80.5448 20.4376C81.6819 20.4376 82.6306 20.0582 83.3893 19.2977C83.8815 18.8026 84.1666 18.1135 84.243 17.2305H80.5448V16.0038H85.4785C85.5294 16.2709 85.5515 16.5279 85.5515 16.7746Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3757 12.511H88.739V15.747H92.9208V16.9737H88.739V20.2098H93.3757V21.4654H87.4304V11.257H93.3757V12.511Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8931 21.4654H97.5845V12.511H94.74V11.257H101.738V12.511H98.8931V21.4654Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.8 21.4654V11.257H108.109V21.4654H106.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.912 21.4654H112.603V12.511H109.759V11.257H116.756V12.511H113.912V21.4654Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.002 20.1468C129.001 21.1778 127.757 21.6934 126.269 21.6934C124.78 21.6934 123.536 21.1778 122.536 20.1468C121.535 19.1157 121.036 17.8533 121.036 16.3612C121.036 14.8691 121.535 13.6066 122.536 12.5756C123.536 11.5446 124.78 11.0273 126.269 11.0273C127.748 11.0273 128.991 11.5463 129.996 12.5824C131 13.6186 131.503 14.8776 131.503 16.3612C131.503 17.8533 131.002 19.1157 130.002 20.1468ZM123.502 19.291C124.256 20.0566 125.177 20.4377 126.269 20.4377C127.36 20.4377 128.283 20.0549 129.035 19.291C129.788 18.5254 130.167 17.5488 130.167 16.3612C130.167 15.1736 129.788 14.197 129.035 13.4314C128.283 12.6658 127.36 12.2847 126.269 12.2847C125.177 12.2847 124.256 12.6675 123.502 13.4314C122.75 14.197 122.372 15.1736 122.372 16.3612C122.372 17.5488 122.75 18.5254 123.502 19.291Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.339 21.4654V11.257H134.931L139.88 19.1974H139.936L139.88 17.2306V11.257H141.189V21.4654H139.822L134.644 13.1388H134.588L134.644 15.1056V21.4654H133.339Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.5515 16.7746C85.5515 18.2003 85.1306 19.3351 84.2871 20.1824C83.3299 21.1897 82.0807 21.6933 80.5465 21.6933C79.0767 21.6933 77.8259 21.1829 76.7991 20.162C75.7706 19.1395 75.2563 17.8737 75.2563 16.3628C75.2563 14.8503 75.7706 13.5845 76.7991 12.5636C77.8259 11.5411 79.0767 11.0307 80.5465 11.0307C81.2763 11.0307 81.9738 11.1736 82.6357 11.4577C83.2993 11.7435 83.8305 12.123 84.2277 12.5976L83.3333 13.496C82.6595 12.6878 81.7311 12.2846 80.5448 12.2846C79.4722 12.2846 78.5455 12.6623 77.7631 13.4177C76.9807 14.1731 76.5903 15.1548 76.5903 16.3611C76.5903 17.5674 76.9807 18.5491 77.7631 19.3045C78.5455 20.0599 79.4722 20.4376 80.5448 20.4376C81.6819 20.4376 82.6306 20.0582 83.3893 19.2977C83.8815 18.8026 84.1666 18.1135 84.243 17.2305H80.5448V16.0038H85.4785C85.5294 16.2709 85.5515 16.5279 85.5515 16.7746Z",
    stroke: "white",
    strokeWidth: 0.340278,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3757 12.511H88.739V15.747H92.9208V16.9737H88.739V20.2098H93.3757V21.4654H87.4304V11.257H93.3757V12.511Z",
    stroke: "white",
    strokeWidth: 0.340278,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8931 21.4654H97.5845V12.511H94.74V11.257H101.738V12.511H98.8931V21.4654Z",
    stroke: "white",
    strokeWidth: 0.340278,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.8 21.4654V11.257H108.109V21.4654H106.8Z",
    stroke: "white",
    strokeWidth: 0.340278,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.912 21.4654H112.603V12.511H109.759V11.257H116.756V12.511H113.912V21.4654Z",
    stroke: "white",
    strokeWidth: 0.340278,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.002 20.1468C129.001 21.1778 127.757 21.6934 126.269 21.6934C124.78 21.6934 123.536 21.1778 122.536 20.1468C121.535 19.1157 121.036 17.8533 121.036 16.3612C121.036 14.8691 121.535 13.6066 122.536 12.5756C123.536 11.5446 124.78 11.0273 126.269 11.0273C127.748 11.0273 128.991 11.5463 129.996 12.5824C131 13.6186 131.503 14.8776 131.503 16.3612C131.503 17.8533 131.002 19.1157 130.002 20.1468ZM123.502 19.291C124.256 20.0566 125.177 20.4377 126.269 20.4377C127.36 20.4377 128.283 20.0549 129.035 19.291C129.788 18.5254 130.167 17.5488 130.167 16.3612C130.167 15.1736 129.788 14.197 129.035 13.4314C128.283 12.6658 127.36 12.2847 126.269 12.2847C125.177 12.2847 124.256 12.6675 123.502 13.4314C122.75 14.197 122.372 15.1736 122.372 16.3612C122.372 17.5488 122.75 18.5254 123.502 19.291Z",
    stroke: "white",
    strokeWidth: 0.340278,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.339 21.4654V11.257H134.931L139.88 19.1974H139.936L139.88 17.2306V11.257H141.189V21.4654H139.822L134.644 13.1388H134.588L134.644 15.1056V21.4654H133.339Z",
    stroke: "white",
    strokeWidth: 0.340278,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1004_6351)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.7858 12.1713C22.2919 12.6953 22 13.5086 22 14.5618V52.1897C22 53.2446 22.2919 54.0561 22.7858 54.5802L22.9114 54.7026L43.9379 33.6241V33.3757V33.1273L22.9114 12.0471L22.7858 12.1713Z",
    fill: "url(#paint0_linear_1004_6351)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.9454 40.6518L43.9377 33.6234V33.375V33.1266L50.9471 26.0999L51.105 26.19L59.4093 30.9199C61.7803 32.2708 61.7803 34.4809 59.4093 35.8335L51.105 40.5634L50.9454 40.6518Z",
    fill: "url(#paint1_linear_1004_6351)"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1004_6351)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.1049 40.563L43.936 33.3763L22.7856 54.5808C23.5664 55.411 24.8579 55.5131 26.3124 54.6862L51.1049 40.563Z",
    fill: "url(#paint2_linear_1004_6351)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M51.1049 26.1884L26.3124 12.0669C24.8579 11.2383 23.5664 11.3421 22.7856 12.1724L43.9377 33.3768L51.1049 26.1884Z",
    fill: "url(#paint3_linear_1004_6351)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M234.408 0.5H7C3.41015 0.5 0.5 3.41015 0.5 7V61.0556C0.5 64.6454 3.41015 67.5556 7 67.5556H234.408C237.998 67.5556 240.908 64.6454 240.908 61.0556V7C240.908 3.41015 237.998 0.5 234.408 0.5Z",
    stroke: "#30363D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.408 0.5H7C3.41015 0.5 0.5 3.41015 0.5 7V61.0556C0.5 64.6454 3.41015 67.5556 7 67.5556H234.408C237.998 67.5556 240.908 64.6454 240.908 61.0556V7C240.908 3.41015 237.998 0.5 234.408 0.5Z",
    stroke: "url(#paint4_linear_1004_6351)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1004_6351",
    x: 22,
    y: 11.2399,
    width: 39.1875,
    height: 44.2727,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.255208
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1004_6351"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.255208
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1004_6351",
    result: "effect2_dropShadow_1004_6351"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1004_6351",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1004_6351",
    x: 22.7856,
    y: 33.1211,
    width: 28.3193,
    height: 22.1363,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -0.255208
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1004_6351"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1004_6351",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1004_6351",
    x1: 42.074,
    y1: 14.1636,
    x2: 13.5214,
    y2: 42.6458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0066,
    stopColor: "#00A1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2601,
    stopColor: "#00BEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5122,
    stopColor: "#00D2FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7604,
    stopColor: "#00DFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00E3FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1004_6351",
    x1: 62.4956,
    y1: 33.375,
    x2: 21.4307,
    y2: 33.375,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFE000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4087,
    stopColor: "#FFBD00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7754,
    stopColor: "#FFA500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9C00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1004_6351",
    x1: 47.2117,
    y1: 37.2792,
    x2: 8.4908,
    y2: 75.9045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF3A44"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C31162"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1004_6351",
    x1: 17.4588,
    y1: -0.353576,
    x2: 34.7488,
    y2: 16.8937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#32A071"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0685,
    stopColor: "#2DA771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4762,
    stopColor: "#15CF74"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8009,
    stopColor: "#06E775"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00F076"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1004_6351",
    x1: 0.499998,
    y1: 4.25743,
    x2: 107.162,
    y2: 166.091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4DDFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46875,
    stopColor: "white",
    stopOpacity: 0.82
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFC774"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1004_6351"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 242,
    height: 69,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaystore);
export default __webpack_public_path__ + "static/media/playstore.886b42a674c89061edea2d5d2682a6e4.svg";
export { ForwardRef as ReactComponent };